import React, { useEffect, useState } from 'react';
import { StyleSheet, Image } from 'react-native';
import { DNABox, DNAButton, DNADivider, DNAText, Iffy, } from '@alucio/lux-ui';
import { isMobile, isTablet } from 'react-device-detect';
import AttendeeJoin from './attendeeJoin/AttendeeJoin';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import { useVideoContext } from '@alucio/video';
const styles = StyleSheet.create({
    header: {
        paddingHorizontal: 24,
        paddingVertical: 16,
    },
    image: {
        height: 310,
        width: 400,
        left: 0,
        top: 10,
        marginTop: 5,
    },
    btnContainerStyle: {
        paddingHorizontal: 24,
        paddingVertical: 16,
        fontWeight: 'bold',
        justifyContent: 'flex-end',
    },
});
var MediaAccessState;
(function (MediaAccessState) {
    MediaAccessState[MediaAccessState["unknown"] = 0] = "unknown";
    MediaAccessState[MediaAccessState["prompted"] = 1] = "prompted";
    MediaAccessState[MediaAccessState["allowed"] = 2] = "allowed";
    MediaAccessState[MediaAccessState["denied"] = 3] = "denied";
    MediaAccessState[MediaAccessState["notAvailable"] = 4] = "notAvailable";
    MediaAccessState[MediaAccessState["notFound"] = 5] = "notFound";
})(MediaAccessState || (MediaAccessState = {}));
var GumExceptions;
(function (GumExceptions) {
    GumExceptions[GumExceptions["unknown"] = 0] = "unknown";
    GumExceptions[GumExceptions["null"] = 1] = "null";
    GumExceptions[GumExceptions["notAllowed"] = 2] = "notAllowed";
    GumExceptions[GumExceptions["notAvailable"] = 3] = "notAvailable";
    GumExceptions[GumExceptions["notFound"] = 4] = "notFound";
})(GumExceptions || (GumExceptions = {}));
export function PreAVCheck({ deniedMediaImage, deniedMedia, accept, }) {
    const INFORMATION_TEXTS = {
        default: {
            title: 'Allow this meeting to use your camera and microphone',
            description: 'This meeting platform needs access to your camera and microphone' +
                ' so other participants can see and hear you.',
            button_text: 'Okay',
        },
        notAllowed: {
            title: 'Please grant permission access',
            description: 'Your access is blocked. Please allow access to your microphone and' +
                ' camera by doing the following steps:' + '\n\n' +
                '1. In your browser search bar, click on the video icon with a small red box' + '\n' +
                '2. Select the “Always allow https...” option' + '\n' +
                '3. Click “Done”',
            button_text: 'Continue without mic & camera',
        },
    };
    const SELECTED_INFO_TEXT = INFORMATION_TEXTS[(deniedMedia) ? 'notAllowed' : 'default'];
    if (!SELECTED_INFO_TEXT) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DNABox, { fill: true, alignY: "center", alignX: "center" },
        React.createElement(DNABox, { appearance: "col", style: { width: 560, backgroundColor: colors['color-text-basic'] } },
            React.createElement(DNABox, { style: styles.header },
                React.createElement(DNAText, { h5: true }, SELECTED_INFO_TEXT.title)),
            React.createElement(DNADivider, null),
            React.createElement(DNABox, { style: { padding: 24 }, appearance: "col" },
                React.createElement(DNAText, { status: "flat", style: { lineHeight: 24 } }, SELECTED_INFO_TEXT.description),
                (deniedMedia) && React.createElement(Image, { source: deniedMediaImage, style: styles.image })),
            React.createElement(Iffy, { is: accept },
                React.createElement(React.Fragment, null,
                    React.createElement(DNADivider, null),
                    React.createElement(DNABox, { style: styles.btnContainerStyle, alignX: "end" },
                        React.createElement(DNAButton, { status: (deniedMedia) ? 'danger' : 'primary', appearance: (deniedMedia) ? 'ghost' : 'filled', size: "medium", onPress: accept }, SELECTED_INFO_TEXT.button_text)))))));
}
export function AVCheck({ deniedMediaImage, meetingName, attendeeName, onJoinMeeting, audioFiles, submitLabel, showDisclaimer, }) {
    const { gumExceptionState, audioAccessState, videoAccessState, } = useVideoContext();
    const [overrideMediaAccessCheck, setOverrideMediaAccessCheck] = useState(false);
    const [acceptDeny, setAcceptDeny] = useState(false);
    const [hideInfoModal, setHideInfoModal] = useState(false);
    useEffect(() => {
        var _a;
        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('mediaaccesscheck') && ((_a = queryParams.get('mediaaccesscheck')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'false') {
            setOverrideMediaAccessCheck(true);
        }
    }, []);
    const accept = function (deniedMedia) {
        if (deniedMedia) {
            setAcceptDeny(true);
        }
        else {
            setHideInfoModal(true);
        }
    };
    if (overrideMediaAccessCheck || acceptDeny || ((audioAccessState === MediaAccessState.allowed ||
        videoAccessState === MediaAccessState.allowed) && gumExceptionState === GumExceptions.null) ||
        audioAccessState === MediaAccessState.notAvailable || audioAccessState === MediaAccessState.notFound ||
        isMobile || isTablet) {
        return (React.createElement(AttendeeJoin, { meetingName: meetingName, attendeeName: attendeeName !== null && attendeeName !== void 0 ? attendeeName : '', onJoinMeeting: onJoinMeeting, deniedMediaImage: deniedMediaImage, mobileView: isMobile, audioFiles: audioFiles, audioAccessState: audioAccessState, videoAccessState: videoAccessState, submitLabel: submitLabel, showDisclaimer: showDisclaimer }));
        // while getUserMedia is being executed or if the user accepted the prompt we display nothing
    }
    else if ((audioAccessState === MediaAccessState.unknown || videoAccessState === MediaAccessState.unknown) ||
        (hideInfoModal && gumExceptionState === GumExceptions.unknown &&
            (audioAccessState === MediaAccessState.prompted || videoAccessState === MediaAccessState.prompted)) ||
        (audioAccessState === MediaAccessState.allowed && videoAccessState === MediaAccessState.allowed)) {
        return React.createElement(React.Fragment, null);
    }
    const deniedMedia = (audioAccessState === MediaAccessState.denied || videoAccessState === MediaAccessState.denied);
    return (React.createElement(PreAVCheck, { mobileView: isMobile, deniedMediaImage: deniedMediaImage, deniedMedia: deniedMedia, accept: () => accept(deniedMedia) }));
}
//# sourceMappingURL=index.js.map